<template>
   <div>
      <div class=" container-fluid   ">
        <div class="llp-container-section  heightcontainer ">
       <top-header id="height2"></top-header>
      <main-menu id="height3"></main-menu>
      <!-- Start the code for this screen here -->
      <div id="deals" class=" container-fluid menu-margin-top" style="padding-left:0px;padding-right:0px" >
         <div>
            <nav class="navbar navbar-expand-lg  bg-info text-white">
               <span><b> Convert App To Deal </b></span>
            </nav>
            <center><span :style="msgcolor"><b>{{information}}</b></span></center>
            <br>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 "><!--row start-->
              <!-- Dealer Name -->
               <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="source" class="col-form-label col-form-label-sm ">Dealer Name</label>
               </div>
               <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">

                  <multiselect
    style="width:100%"
    name="proposedLessee"
    v-model="selectedDealerId"
    :options="dealersList"
    :value="dealersList.dealerId"
    :custom-label="displayDealerFullName"
    selected="selected"
    id="customersdd">
  </multiselect>
               </div>
               <!-- date range -->
               <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="quote" class="col-form-label col-form-label-sm required"> Date Range </label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <input type="Date" v-model.trim="fromDate" v-validate="'required'" class="form-control input-sm"
                  name="DFrom" data-vv-as="Date Range" />
                <div v-if="errors.has('DFrom')" class="alert-danger"> {{ "Date Range is Mandatory" }} </div>
              </div>
              <div
                class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <input type="Date" v-model.trim="toDate" class="form-control input-sm" v-validate="'required'"
                  name="DFrom" data-vv-as="Date Range" />
              </div>
            </div><!-- row end-->

            <!-- lesse name fraud reason -->
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
               <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="source" class="col-form-label col-form-label-sm "> Lessee Name</label>
               </div>
               <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <multiselect
    style="width:100%"
    name="proposedLessee"
    v-model="selectedCustomerId"
    :options="appCustomersList"
    :value="appCustomersList.customerId"
    :custom-label="displayCustomerFullName"
    selected="selected"
    id="customersdd">
  </multiselect>
               </div>
               <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center" v-if="customerFraudReason!=null">
     <label class="col-form-label col-form-label-sm">Lessee Fraud Reason</label>
    </div>
    <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3" v-if="customerFraudReason!=null&& customerFraudReason!='Review'">
      <label style="background-color:Red; text-align:center; float:left" class="col-form-label col-form-label-sm">{{customerFraudReason}}</label>
    </div>
    <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3" v-if="customerFraudReason!=null&& customerFraudReason=='Review'">
      <label style="background-color:Orange; text-align:center; float:left" class="col-form-label col-form-label-sm">{{customerFraudReason}}</label>
    </div>
            </div>

            <!-- dealer state sourcce -->
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Dealer State</label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect style="width:100%" name="proposedLessee" v-model="selectedDealerState"
                  :options="quoteDealerStateList" :value="quoteDealerStateList.stateFipsC"
                  :custom-label="displayStateFullName" selected="selected" id="customersdd">
                </multiselect>
              </div>
              
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                     <label for="source" class="col-form-label col-form-label-sm "> Source </label>
                  </div>
                  <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                     <!-- <input type="text"  name="source" v-model.trim="selectedappdetails.source" >-->
                     <select name="source" ref="source" v-model.trim="selectedSource" class="form-control input-sm " data-vv-as="Source">
                        <option disabled  value=""> Select a Source</option>
                        <option v-for="(option,index) in sources" :value="option.sourceName" :key="index">{{ option.sourceName }}</option>
                     </select>
                  </div>
            </div>

            <!-- underwriter and sales rep name -->
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Underwriter Name</label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect style="width:100%" name="proposedLessee" v-model="selectedCreditAnalystId"
                  :options="quoteCreditAnalystList" :value="quoteCreditAnalystList.employeeId"
                  :custom-label="displayFullName" selected="selected" id="creditAnalyst">
                </multiselect>
              </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Salesperson Name</label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect style="width:100%" name="proposedLessee" v-model="selectedAgentId"
                :options="agentList"
                :value="agentList.employeeId"
                :custom-label="displayFullName"
                  selected="selected" id="customersdd">
                </multiselect>
              </div>
            </div>

            <!-- Lease Number date type -->

            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 py-2 mx-0">
                    <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                      <label for="leaseNumber" class="col-form-label col-form-label-sm">Lease Number</label>
                    </div>
                    <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                      <select name="changeApp" v-model.trim="leaseNumber" class="form-control input-sm">
                        <option value>Select Lease</option>
                        <option v-for="lease in leaseNumberList" v-bind:value="lease" v-bind:key="lease">{{ lease }}</option>
                      </select>
                    </div>
                    <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                      <label for="Date Type" class="col-form-label col-form-label-sm">Date Type</label>
                    </div>
                    <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                      <select v-model="dateType" class="form-control input-sm">
                        <option v-for="(option, index) in status" :value="option.status" :key="index">{{ option.status }}
                        </option>
                      </select>
                    </div>
                  </div>


            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
               <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="stateofReg" class="col-form-label col-form-label-sm ">State of Reg</label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                   <multiselect
    style="width:100%"
    name="proposedLessee"
    v-model="selectedAppState"
    :options="appStates"
    :value="appStates.stateFipsC"
     :custom-label="displayStateFullName"
    selected="selected"
    id="customersdd">
  </multiselect>
               </div>
               <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="source" class="col-form-label col-form-label-sm ">Year </label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                   <multiselect
    style="width:100%"
    name="proposedLessee"
    v-model="appYear"
    :options="appYears"
    :value="appYears"
    selected="selected"
    id="customersdd">
  </multiselect>
               </div>

            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
               <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="make" class="col-form-label col-form-label-sm ">Make</label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <multiselect
    style="width:100%"
    name="proposedLessee"
    v-model="appMake"
    :options="appMakes"
    :value="appMakes"
    selected="selected"
    id="customersdd">
  </multiselect>
               </div>

               <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center" >
                  <label for="source" class="col-form-label col-form-label-sm ">Model</label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <multiselect
    style="width:100%"
    name="proposedLessee"
    v-model="appModel"
    :options="appModels"
    :value="appModels"
    selected="selected"
    id="customersdd">
  </multiselect>
               </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="source" class="col-form-label col-form-label-sm ">App Status </label>
               </div>
               <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <select v-model.trim="selectedAppStatus" class="form-control input-sm ">
                     <option  value="" > Select App Status </option>
                     <option v-for="status in listAppStatus" :value="status.value" v-bind:key="status.key">{{ status.value}}</option>
                  </select>
               </div>
               <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="source" class="col-form-label col-form-label-sm ">Deal Status </label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <select v-model.trim="selectedDealStatus" class="form-control input-sm ">
                     <option  value="" > Select Deal Status </option>
                     <option v-for="status in dealStatusList" v-bind:value="status.value" v-bind:key="status.key"> {{ status.value}} </option>
                  </select>
               </div>
            </div>
            <div class="width100" >
               <br>
               <center>
                <button type="submit" @click="retrieveApplicationSearchDetails" class="btn btn-secondary mr-3">Search</button>
                  <button
                     type="submit" class="btn btn-secondary" @click="resetFilters">Reset</button>
               </center>
            </div>
            <br>
            <div class="row p-2 justify-content-center">
               <div class="col">
                <div
                  class="table-responsive table-responsive-sm"
                  style="overflow:auto;"
                >
                  <v-table
                    id="myappsTable"
                    :data="filteredApps"
                    :pageSize="25"
                    @totalPagesChanged="totalPages = $event"
                    class="table table-sm table-bordered table-striped"
                  >
                    <thead class="table-month-header-blue wrap-text" slot="head">
                      <v-th sortKey="applicationId">Select</v-th>
                      <v-th sortKey="proposedLesseeName">Lessee Name</v-th>
                      <v-th sortKey="fraudreason">Customer Fraud Reason</v-th>
                      <v-th sortKey="businessContactFullName">Business Contact Name</v-th>
                      <v-th sortKey="appdate">App Date</v-th>
                      <v-th sortKey="make">Year</v-th>
                      <v-th sortKey="make">Make</v-th>
                      <v-th sortKey="model">Model</v-th>
                      <v-th sortKey="appStatus">App Status</v-th>
                      <v-th sortKey="dealStatuss">Deal Status</v-th>
                      <v-th sortKey="quoteState">State of Reg</v-th>
                      <v-th sortKey="loanAmount">Loan Amount</v-th>
                      <v-th sortKey="dealerName">Dealer Name</v-th>
                    </thead>
                    <tbody slot="body" slot-scope="{ displayData }">

                        <tr v-for="(app,index) in  displayData"  :class="colorRow(app.applicationId)"  :key="index">
                           <td class="table-month-td"> <input type="radio" v-on:click="viewAppDetails(app.applicationId,index)" v-model="selectedapp" v-bind:value="app.applicationId" > </td>
                           <td class="table-month-td">{{ app.proposedLesseeName}}</td>
                           <td class="table-month-td" v-if="app.fraudreason!=null&&app.fraudreason!='Review'" style="background-color: Red">{{ app.fraudreason }} </td>
                           <td class="table-month-td" v-if="app.fraudreason!=null&&app.fraudreason=='Review'" style="background-color: Orange">{{ app.fraudreason }} </td>
                           <td class="table-month-td" v-if="app.fraudreason==null">{{ app.fraudreason }} </td>
                           <td class="table-month-td">{{ app.businessContactFullName}}</td>
                           <td class="table-month-td">{{app.appDate| moment("MM/DD/YYYY")}}</td>
                           <td class="table-month-td">{{app.year}}</td>
                           <td class="table-month-td">{{app.make}}</td>
                           <td class="table-month-td">{{app.model}}</td>
                           <td class="table-month-td">{{app.appStatus}}</td>
                           <td class="table-month-td">{{app.dealStatus}}</td>
                           <td class="table-month-td">{{app.quoteState}}</td>
                           <td class="table-month-td">{{app.loanAmount}}</td>
                           <td class="table-month-td">{{app.dealerName}}</td>
                        </tr>
                    </tbody>
                     </v-table>
                     <!-- <smart-pagination
                    :currentPage.sync="currentPage"
                    :totalPages="totalPages"
                    :style="{ listStyle: none }"
                  /> -->
                  
                  <b-pagination v-if="totalPages > 0"  
                      align="right"
                      v-model="currentPage"
                      :total-rows="totalElements"
                      :per-page="perPage"
                      aria-controls="myappsTable"
                      @change="handleClick($event)"
                      :class="{ 'd-none': isLoading || filteredApps.length == 0}">
                    </b-pagination>
                    <template v-if="filteredApps.length == 0 && !isLoading">
                      <center>
                          <span>
                              <b>No records found</b>
                              <br />
                          </span>
                      </center>
                  </template>
                  <template v-if="isLoading">
                        <div class="d-flex justify-content-center align-items-center">
                          <strong>Loading...</strong>
                          <b-spinner variant="primary" label="Spinning"></b-spinner>
                        </div>
                  </template>
                  </div>
               </div>
            </div>
            <div  v-if="selectedapp != ''">
               <br>
               <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                  <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                     <label for="source" class="col-form-label col-form-label-sm "> Lease Number </label>
                  </div>
                 <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                     <input type="text"  class="form-control input-sm " name="make" v-model.trim="selectedappdetails.leaseNumber">
                  </div>
               </div>
               <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                  <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                     <label for="source" class="col-form-label col-form-label-sm "> Source </label>
                  </div>
                  <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                     <!-- <input type="text"  name="source" v-model.trim="selectedappdetails.source" >-->
                     <select name="source" ref="source" v-model.trim="selectedappdetails.source" class="form-control input-sm " v-validate="'required'"  data-vv-as="Source" @change="updateDealer">
                        <option disabled  value=""> Select a Source</option>
                        <option v-for="(option,index) in sources" :value="option.sourceName" :key="index">{{ option.sourceName }}</option>
                     </select>
                  </div>
                  <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                     <label for="salesAgent" class="col-form-label col-form-label-sm ">  Salesperson Name</label>
                  </div>
                  <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">

                     	<multiselect
    style="width:100%"
    name="proposedLessee"
    v-model="selectedEmployeeData"
    :options="agentList"
    :value="agentList.employeeId"
    :custom-label="displayFullName"
    @input="getAgentDetails(selectedEmployeeData.employeeId), updateDealer(selectedEmployeeData.employeeId)"
    selected="selected"
    id="customersdd">
  </multiselect>
                     <!-- <input type="text"  name="salesAgent" v-model.trim="selectedappdetails.salesAgent" readonly="true">-->
                  </div>
                  <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                     <label for="dealerName" class="col-form-label col-form-label-sm "> Dealer Name </label>
                  </div>
                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                     <!--<select name="dealerName" v-model.trim="quote.dealerId">-->

                     <multiselect
    style="width:100%"
    name="dealerName"
    v-model="selectedDealerData"
    :options="sortedDealers"
    :value="sortedDealers.dealerId"
   label="dealerName"
    @input="getDealerDetails(selectedDealerData.dealerId)"
    selected="selected"
    id="customersdd">
    </multiselect>
                  </div>
               </div>
               <br>
               <nav class="navbar navbar-expand-lg  bg-info text-white"><span><b> Vehicle Information</b></span></nav>
               <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
        <label for="currentMiles"  class="col-form-label col-form-label-sm "> Vin Number </label>
        </div>
        <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
            <input type="text"   name="Vin Number"  v-validate="'min:6'" data-vv-as="Vin Number" v-model.trim="selectedappdetails.vin" @input="getVinFraudReason(selectedappdetails.vin)" class="form-control input-sm "  placeholder="Enter Min Last 6 characters">
            <div v-if="errors.has('Vin Number')" class="alert-danger">{{ errors.first('Vin Number') }}</div>
        </div>
        <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center" v-if="selectedappdetails.vin!='' && selectedappdetails.vinFraudReason!=null">
        <label for="currentMiles"  class="col-form-label col-form-label-sm"> Vin Fraud Reason </label>
        </div>
        <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center" v-if="selectedappdetails.vin!='' && selectedappdetails.vinFraudReason!=null">
        <label for="currentMiles" style="background-color:Red; text-align:center;float:left"  > {{selectedappdetails.vinFraudReason}} </label>
        </div>
        </div>

               <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                  <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                     <label for="make" class="col-form-label col-form-label-sm "> Make </label>
                  </div>
                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                     <input type="text"  class="form-control input-sm " name="make" v-model.trim="selectedappdetails.make">
                  </div>
                  <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                     <label for="model" class="col-form-label col-form-label-sm "> Model </label>
                  </div>
                  <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                     <input type="text"   name="model" class="form-control input-sm " v-model.trim="selectedappdetails.model">
                  </div>
                  <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                     <label for="year" class="col-form-label col-form-label-sm "> Year </label>
                  </div>
                  <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                     <input type="text"   name="year" class="form-control input-sm " v-model.trim="selectedappdetails.year"   >
                  </div>
               </div>
               <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                  <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                     <label for="loanamount" class="col-form-label col-form-label-sm "> Loan Amount </label>
                  </div>
                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                     <input type="text"   name="loanamount" class="form-control input-sm " v-model.trim="selectedappdetails.loanAmount"  >
                  </div>

               </div>
               <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
               <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center" v-if="this.vincontinue == 'Approval'">
        <label for="currentMiles" class="col-form-label col-form-label-sm required"> Fraud Managers Approval</label>
        </div>
        <div class="col-12 col-lg-4 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 " v-if="this.vincontinue == 'Approval'">
        <input type="text" name="Approval Note" v-validate="'required'" @input="enableSubmit()" data-vv-as="Approval Note" class="form-control input-sm " placeholder="From: Jim Moscatello|Rich Bricker|Doug Goodman" v-model.trim="selectedappdetails.overrideFraud">
        <div v-if="errors.has('Approval Note')" class="alert-danger">{{ errors.first('Approval Note') }}</div>
        </div>
               </div>
         <div id="myModal" class="modal">
               <div class="modal-content">
               <div class="modal-header">
            <h2>Fraud Alert</h2>
               </div>
               <div class="modal-body">
               There is fraud block. To continue, override provide supervisor
               </div>
               <br>
                  <div class="modal-footer"><button class="btn-blue-save submitButton" @click="fraudoverride()">OK</button>
               </div>
               </div>
            </div>
            <div id="vinDecoder" class="modal">
      <div class="modal-content">
        <div class="modal-header">
    <h2>No Vehicle Found</h2>
        </div>
        <div class="modal-body">
      {{vehicleInfoMessage}}
        </div>
        <br>
         <div class="modal-footer"><button class="btn-blue-save nextButton" @click="clearVIN()">OK</button>
        </div>
      </div>
 </div>
               <br>
               <nav class="navbar navbar-expand-lg  bg-info text-white"><span><b> Status</b></span></nav>
               <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                  <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                     <label for="dealStatus"  class="col-form-label col-form-label-sm  required"> Deal Status </label>
                  </div>
                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                     <select v-validate="'required'" name="dealStatus" class="form-control input-sm " v-model.trim="dealStatus" data-vv-as="Deal Status" @change="disableFundedDate">
                        <option disabled value=""> Select Deal Status </option>
                        <option v-for="status in dealStatusList" v-bind:value="status.value" v-bind:key="status.key"> {{ status.value}} </option>
                     </select>
                     <div v-if="errors.has('dealStatus')" class="alert-danger">{{ errors.first('dealStatus') }}</div>
                  </div>
                  <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                     <label for="fundedDate" class="col-form-label col-form-label-sm "> Funded Date </label>
                  </div>
                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                     <input type="Date"  v-model.trim="fundedDate" :disabled="disabledfields" class="form-control input-sm " />
                  </div>
               </div>
               <div  v-if="dealStatus == 'Declined By LLP' || dealStatus == 'Declined By Customer'" class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                  <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                     <label for="declineReason"  class="col-form-label col-form-label-sm required"> Deal Decline Reason </label>
                  </div>
                  <textarea  v-model.trim="declineReason" data-vv-as="Decline Reason"  name="declineReason"   v-validate="'required'" spellcheck="true" placeholder="Decline Reason"
                     rows="5" cols="20" style="width: 52.4%;" :maxlength="250" />
               </div>
               <div>
                  <div class="col  d-flex justify-content-end align-items-center">
                     <label for="dummy">  </label>
                  </div>
                  <div v-if="errors.has('declineReason')" class="alert-danger">{{ errors.first('declineReason') }}</div>
               </div>

                  <div class="center">
                     <button id="submitbutton"
                     type="submit" class="btn btn-secondary" @click="saveapplicationdata">Submit</button>
               </div>
               <br><br>
            </div>
         </div>
      </div>
      <!-- End of the code for this screen here -->
      <bottom-footer></bottom-footer>
        </div>
      </div>
   </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import httpemployee from '../js/http-employee.js'
import httpcustomer from '../js/http-customer.js'
import dealsjson from '../json/quotes.json'
import lookup from '../prod-json/lookupvalues.json'
import httpsource from '../js/http-managesource.js'
import httpdeal from '../js/http-dealstracking.js'
import util from '../js/common-utils.js'
import moment from 'moment'
export default {
  components: { MainMenu,
    TopHeader,
    BottomFooter
  },
  data () {
    return {
      appIdList: '',
      vehicleInfoMessage: '',
      selectedEmployeeData: '',
      selectedDealerData: '',
      selectedapp: '',
      dealersList: [],
      disabledfields: 'disabled',
      agentList: [],
      modifiedsalesAgent: '',
      sources: [
        { sourceName: 'Dealer' },
        { sourceName: 'InHouse' }
      ],
      dealStatusList: lookup[0].lookupValues,
      selectedappdetails: [],
      information: '',
      msgcolor: {
        color: 'black'
      },
      heads: [
        { name: 'Select' },
        { name: 'Lessee Name' },
        { name: 'Customer Fraud Reason' },
        { name: 'Business Contact Name' },
        { name: 'App Date' },
        { name: 'Year' },
        { name: 'Make' },
        { name: 'Model' },
        { name: 'App Status' },
        { name: 'Deal Status' },
        { name: 'State of Reg' },
        { name: 'Loan Amount' },
        { name: 'Dealer Name' }
      ],
      listAppStatus: lookup[0].lookupValues,
      dealStatus: '',
      currentPage: 1,
      totalPages: 0,
      fundedDate: '',
      declineReason: '',
      listApps: [],
      filters: [],
      selectedDealStatus: '',
      selectedDealerId: '',
      selectedCustomerId: '',
      selectedAppState: '',
      selectedAppStatus: 'Approved',
      appYear: '',
      appMake: '',
      appModel: '',
      vincontinue: null,
      enablebutton: false,
      listDealStatus: [],
      dealersList: [],
      appCustomersList: [],
      fraudReasons: [],
      customerFraudReason: null,
      appStates: [],
      appYears: [],
      appMakes: [],
      appModels: [],
      quotedealersList: [],
      quoteCustomersList: [],
      quoteAgentsList: [],
      fromDate: moment().subtract(60, 'days').format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      quoteDealerStateList: [],
      selectedDealerState: "",
      quoteAgentsList: [],
      quoteCreditAnalystList: [],
      selectedCreditAnalystId: '',
      selectedAgentId: '',
      leaseNumber: '',
      status: [
        { status: 'AppDate' },
        { status: 'FundedDate' },
      ],
      dateType: '',
      selectedSource: '',
      leaseNumberList: [],
      selectedCreditAnalystData: '',
      totalElements: 0,
      isLoading: false,
      perPage: 10,
    }
  },
  mounted () {
    this.fetchData()
    this.myFunction()
    this.menuheight()
    this.fromDate = moment().subtract(60, 'days').format('YYYY-MM-DD')
    this.toDate = moment().format('YYYY-MM-DD')
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },
  methods: {
    displayCustomerFullName (option) {
      if (option.customerType == 'P') {
        return `${option.firstName} ${option.middleName != null && option.middleName.length != 0 ? ',' + option.middleName : ''} ,${option.lastName != null && option.lastName.length != 0 ? option.lastName : ''}`
      } else if (option.customerType == 'B') {
        return `${option.businessName}`
      }
    },
    displayFullName (option) {
      return `${option.firstName} ${option.middleName != null && option.middleName.length != 0 ? ',' + option.middleName : ''} ,${option.lastName != null && option.lastName.length != 0 ? option.lastName : ''}`
    },
    displayDealerFullName (option) {
      return `${option.dealerName}`
    },
    displayStateFullName (option) {
      return `${option.stateN}`
    },
    getAgentDetails (employeeId) {
      if (employeeId >= 0) {
        httpemployee.get('/employee/' + employeeId).then(response => {
          var employeelist = response.data
          this.selectedEmployeeData = employeelist[0]
          // console.log("ID : " + JSON.stringify(this.selectedEmployeeData))
        })
          .catch(e => {
            this.errors.push(e)
          })
      }
    },
    getDealerDetails (dealerId) {
      if (dealerId >= 0) {
        httpsource.get('/dealerbyid/' + dealerId).then(response => {
          var dealerlist = response.data
          this.selectedDealerData = dealerlist
          // console.log("ID : " + JSON.stringify(this.selectedDealerData))
        })
          .catch(e => {
            this.errors.push(e)
          })
      }
    },
    resetFilters: function () {
      this.filters = []
      this.selectedAppStatus = 'Approved'
      this.selectedDealStatus = ''
      this.selectedDealerId = ''
      this.selectedCustomerId = ''
      this.selectedAppState = ''
      this.appYear = ''
      this.appMake = ''
      this.appModel = ''
      this.customerFraudReason = null
      this.selectedapp = ''
      this.information = ''
      this.selectedDealerState = "";
      this.selectedCreditAnalystId = '';
      this.selectedAgentId = '';
      this.leaseNumber = '';
      this.dateType = '';
      this.selectedSource = '';
      this.selectedCreditAnalystData = '';
      this.currentPage = 1;
      this.retrieveApplicationSearchDetails()
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#deals').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    },

    selectIfOnlyOneApp: function () {
      if (this.filteredApps.length == 1) {
        this.selectedapp = this.filteredApps[0].applicationId
        this.viewAppDetails(this.filteredApps[0].applicationId, 0)
      } else {
        this.selectedapp = ''
      }
    },
    filterDealerName: function () {
      // iterate the filters and remove the name dealerId
      var i = this.filters.length
      while (i--) {
        if (this.filters[i].name === 'dealerId') {
          this.filters.splice(i, 1)
        }
      }
      if (this.selectedDealerId !== '') {
        this.filters.push({
          name: 'dealerId',
          value: this.selectedDealerId.dealerId
        })
      }
      this.selectIfOnlyOneApp()
    },
    filterLessee: function () {
      // iterate the filters and remove the name customerId
      var i = this.filters.length
      while (i--) {
        if (this.filters[i].name === 'customerId') {
          this.filters.splice(i, 1)
        }
      }
      if (this.selectedCustomerId !== '') {
        this.filters.push({
          name: 'customerId',
          value: this.selectedCustomerId.customerId
        })
      }
      this.getFraudCustomer(this.selectedCustomerId.customerId)
      this.selectIfOnlyOneApp()
    },
    getFraudCustomer (customerId) {
      httpdeal.get('/quote/dealsTrackingFraudCustomer?customerId=' + parseInt(customerId)).then(response => {
	  if (response.data[0].customerFraudReason != '') { this.customerFraudReason = response.data[0].customerFraudReason } else { this.customerFraudReason = null }
      })
    },
    filterMake: function () {
      // iterate the filters and remove the name make
      var i = this.filters.length
      while (i--) {
        if (this.filters[i].name === 'make') {
          this.filters.splice(i, 1)
        }
      }
      if (this.appMake !== '') {
        this.filters.push({
          name: 'make',
          value: this.appMake
        })
      }
      this.selectIfOnlyOneApp()
    },
    filterModel: function () {
      // iterate the filters and remove the name model
      var i = this.filters.length
      while (i--) {
        if (this.filters[i].name === 'model') {
          this.filters.splice(i, 1)
        }
      }
      if (this.appModel !== '') {
        this.filters.push({
          name: 'model',
          value: this.appModel
        })
      }
      this.selectIfOnlyOneApp()
    },

    filterYear: function () {
      // iterate the filters and remove the name year
      var i = this.filters.length
      while (i--) {
        if (this.filters[i].name === 'year') {
          this.filters.splice(i, 1)
        }
      }
      if (this.appYear !== '') {
        this.filters.push({
          name: 'year',
          value: this.appYear
        })
      }
      this.selectIfOnlyOneApp()
    },
    filterState: function () {
      // iterate the filters and remove the name quotestate
      var i = this.filters.length
      while (i--) {
        if (this.filters[i].name === 'quoteState') {
          this.filters.splice(i, 1)
        }
      }
      if (this.selectedAppState !== '') {
        this.filters.push({
          name: 'quoteState',
          value: this.selectedAppState.stateFipsC
        })
      }
      this.selectIfOnlyOneApp()
    },
    // filterAppStatus: function () {
    //   // iterate the filters and remove the name dealerId
    //   var i = this.filters.length
    //   while (i--) {
    //     if (this.filters[i].name === 'appStatus') {
    //       this.filters.splice(i, 1)
    //     }
    //   }
    //   if (this.selectedAppStatus !== '') {
    //     this.filters.push({
    //       name: 'appStatus',
    //       value: this.selectedAppStatus
    //     })
    //   }
    //   this.selectIfOnlyOneApp()
    // },
    // filterDealStatus: function () {
    //   // iterate the filters and remove the name deal Status
    //   var i = this.filters.length
    //   while (i--) {
    //     if (this.filters[i].name === 'dealStatus') {
    //       this.filters.splice(i, 1)
    //     }
    //   }
    //   if (this.selectedDealStatus !== '') {
    //     this.filters.push({
    //       name: 'dealStatus',
    //       value: this.selectedDealStatus
    //     })
    //   }
    //   this.selectIfOnlyOneApp()
    // },

    updateDealer (employeeId) {
      this.dealersList = []

      if (this.selectedappdetails.source == 'InHouse') {
        httpsource.get('/dealersearch').then(response => {
          if (response.data.length != 0) {
            this.dealersList = []
            this.dealersList = response.data
          }
        })
          .catch(error => {
            console.log('Failed to load dealers:' + error)
          })
      } else if (employeeId != undefined) {
        httpemployee.get('/employee/' + parseInt(employeeId)).then(response => {
          this.dealersList = []
          // this.quote.dealerId=''
					 for (var i = 0; i < response.data.length; i++) {
            var employeeobject = response.data[i]
            for (var i = 0; i < employeeobject.empBusinessCoverageAreas.length; i++) {
              var empbuscovarea = employeeobject.empBusinessCoverageAreas[i]
              this.dealersList.push({
                'dealerId': empbuscovarea.id.dealerId,
                'dealerName': empbuscovarea.ddealerInfo.dealerName
              })
            }
					 }
        }).catch(e => { console.log(e) })
      }
    },
    disableFundedDate () {
      if (!(this.dealStatus == 'Declined By LLP' || this.dealStatus == 'Declined By Customer')) {
        this.declineReason = ''
      }
      if (this.dealStatus == 'Approved') {
        this.disabledfields = false
      } else if (this.dealStatus != 'Approved') {
        this.disabledfields = true
        this.fundedDate = ''
      }
    },
    colorRow: function (appID) {
      if (appID === this.selectedapp) { return 'selected-deal' } else { return 'non-selected-deal' }
    },
    saveapplicationdata () {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          var hour = new Date().getHours()
          var minutes = new Date().getMinutes()
          var seconds = new Date().getSeconds()
          var milliseconds = new Date().getMilliseconds()
          this.selectedappdetails.dealStatus = this.dealStatus
          this.selectedappdetails.lastUpdatedUserI = this.$session.get('user_id')

          if (this.fundedDate != '') {
            this.selectedappdetails.fundedDate = util.strToDate(this.fundedDate)
          } else {
            this.selectedappdetails.fundedDate = this.fundedDate
          }

          this.selectedappdetails.salesAgent = this.selectedEmployeeData.employeeId
          this.selectedappdetails.proposedLesseeName = ''
          this.selectedappdetails.dealerName = ''
          this.selectedappdetails.salesAgentName = ''
          this.selectedappdetails.businessContactFullName = ''
          this.selectedappdetails.dealDeclineReason = this.declineReason
          this.selectedappdetails.dealerId = this.selectedDealerData.dealerId
          httpdeal.put('/application/convertapplication', this.selectedappdetails).then(response => {
            var status = response.data
            if (status == 'ACCEPTED') {
              this.information = 'Application converted to Deal Successfully'
              this.msgcolor.color = 'Blue'
              this.retrieveApplicationDetails()
              this.initializedata()

              this.selectedapp = ''
            } else {
              this.msgcolor.color = 'Red'
              this.information = ''
              this.retrieveApplicationDetails()
              this.initializedata()

              this.selectedapp = ''
            }
          })
            .catch(e => {
              this.msgcolor.color = 'Red'
              this.information = '' || e.name || e.message
              this.retrieveApplicationDetails()
              this.initializedata()
              this.selectedapp = ''
            })
        }
      })
    },
    getVehicleInfo (vin) {
      httpdeal.get('/quote/getVechicleInfo/' + vin).then(response => {
        if (response.data[0].year == null && response.data[0].make == null && response.data[0].model == null && response.data[0].trim == null) {
          httpdeal.get('/quote/getVechicleInfoMessage').then(response => {
            this.vehicleInfoMessage = response.data
          })
          var modal = document.getElementById('vinDecoder')
          modal.style.display = 'block'
          this.selectedappdetails.year = ''
          this.selectedappdetails.make = ''
          this.selectedappdetails.model = ''
        } else {
          this.selectedappdetails.year = response.data[0].year
          this.selectedappdetails.make = response.data[0].make
          this.selectedappdetails.model = response.data[0].model
        }
      })
        .catch(e => {
          console.log(e)
          this.errors.push(e)
        })
    },
    clearVIN () {
      var modal = document.getElementById('vinDecoder')
      modal.style.display = 'none'
      this.vehicleInfoMessage = ''
    },
    getVinFraudReason (vin) {
      if (this.selectedappdetails.vin != null || this.selectedappdetails.vin != ' ') {
        if (this.selectedappdetails.vin.length >= 6) {
          this.getVehicleInfo(this.selectedappdetails.vin)
          httpcustomer.get('customer/getVinFraudDetails?vin=' + vin).then(response => {
            if (response.data[0].vinFraudReason != null && response.data[0].vinFraudReason.length != 0) {
              this.selectedappdetails.vinFraudReason = response.data[0].vinFraudReason
              if (this.selectedappdetails.vinFraudReason != null && this.selectedappdetails.overrideFraud == null) {
                var modal = document.getElementById('myModal')
                modal.style.display = 'block'
                this.vincontinue = 'Approval'
                this.enablebutton = true
              } else if (this.selectedappdetails.vinFraudReason != null && this.selectedappdetails.overrideFraud != null) {
                this.vincontinue = 'Approval'
                this.enablebutton = false
              } else {
                this.selectedappdetails.vinFraudReason = null
                this.selectedappdetails.overrideFraud = null
                this.enablebutton = false
                this.vincontinue = null
              }
            } else {
              this.selectedappdetails.vinFraudReason = null
              this.vincontinue = null
              this.selectedappdetails.overrideFraud = null
              this.enablebutton = false
            }
          })
            .catch(e => {
              console.log(e)
              this.errors.push(e)
            })
        } else {
          this.selectedappdetails.vinFraudReason = null
          this.vincontinue = null
          this.selectedappdetails.overrideFraud = null
          this.enablebutton = false
        }
      } else {
        this.selectedappdetails.vinFraudReason = null
        this.vincontinue = null
        this.selectedappdetails.overrideFraud = null
        this.enablebutton = false
      }
    },
    fraudoverride () {
      if (this.selectedappdetails.vinFraudReason != null) {
        this.vincontinue = 'Approval'
        var modal = document.getElementById('myModal')
        modal.style.display = 'none'
      }
    },

    enableSubmit () {
      this.enablebutton = false
    },
    retrieveApplicationDetails: function () {
      httpdeal.get('/application/dealStatus/Approved,Closed').then(response => {
        if (response.data[0].errorMessage != null && response.data[0].errorMessage.length > 0) {
          this.listApps = []
          this.information = 'No Approved Application in the system'
          this.msgcolor.color = 'Red'
        } else {
          var arr = []
          var j = 0
          var fraudreason = []
          var listApps1 = []
          var listApps1 = response.data

          for (var i = 0; i < listApps1.length; i++) {
            arr.push(listApps1[i].customerId)
          }
          httpdeal.get('/quote/dealsTrackingFraudCustomer?customerId=' + arr).then(response => {
            fraudreason = response.data
            for (j = 0; j < listApps1.length; j++) {
              for (var k = 0; k < fraudreason.length; k++) {
                if (listApps1[j].customerId == fraudreason[k].customerId) {
                  if (fraudreason[k].customerFraudReason != '') { listApps1[j]['fraudreason'] = fraudreason[k].customerFraudReason } else { listApps1[j]['fraudreason'] = null }
                }
              }
            }
            this.listApps = listApps1
          })
        }
      })

        .catch(e => {
          this.errors.push(e)
        })
    },
    initializedata () {
      return {
        source: '',
        dealerName: '',
        firstName: '',
        lastName: '',
        salesAgent: '',
        make: '',
        model: '',
        year: '',
        loanamount: '',
        vinFraudReason: null,
        overrideFraud: null,
        vin: null

      }
    },
    viewAppDetails: function (appId, index) {
      httpdeal.get('/application/appId/' + appId).then(response => {
        this.appIdList = response.data
        this.selectedappdetails = this.appIdList[0]
        this.fundedDate = moment(this.appIdList[0].fundedDate).utc().format('YYYY-MM-DD')
        this.declineReason = this.appIdList[0].dealDeclineReason
        this.modifiedsalesAgent = this.appIdList[0].salesAgent
        this.dealStatus = this.appIdList[0].dealStatus
        this.getAgentDetails(this.appIdList[0].salesAgent)
        this.updateDealer(this.appIdList[0].salesAgent)
        this.getDealerDetails(this.selectedappdetails.dealerId)
        this.disableFundedDate()
        this.information = ''
        this.getVinFraudReason(this.appIdList[0].vin)
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    createSearchObject () {
      return {
        'firstName': '',
        'lastName': '',
        'roleType': '',
        'statusCode': 'A'
      }
    },
    retrieveAgentList () {
      let searchEmployee = this.createSearchObject()
      httpemployee.post('/employee/search/', searchEmployee).then(response => {
        // this.agentList = response.data
        this.agentList = response.data.filter((employee) => {
            return employee.userRoles && Array.isArray(employee.userRoles) && 
            employee.userRoles.some(role => role.userRoleC === 'SR');
          })

          this.quoteCreditAnalystList = response.data.filter((employee) => {
            return employee.userRoles && Array.isArray(employee.userRoles) && 
            employee.userRoles.some(role => role.userRoleC === 'CA');
          })
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    retrieveAllDealers: function () {
      httpdeal.get('/application/dealers').then(response => {
        this.dealersList = response.data
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    retrieveAllLesseeNames: function () {
      httpdeal.get('/application/customers').then(response => {
        this.appCustomersList = response.data
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    retrieveAllStates: function () {
      httpdeal.get('/application/appstate').then(response => {
        this.appStates = response.data
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    retrieveAllYears: function () {
      httpdeal.get('/application/lmyears').then(response => {
        this.appYears = response.data
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    retrieveAllMakes: function () {
      httpdeal.get('/application/lmmake').then(response => {
        this.appMakes = response.data
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    retrieveAllModels: function () {
      httpdeal.get('/application/lmmodel').then(response => {
        this.appModels = response.data
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    // retrieveAllDealStatus: function () {
    //   httpdeal.get('/application/appdealstatus').then(response => {
    //     this.listDealStatus = response.data
    //   })
    //     .catch(e => {
    //       this.errors.push(e)
    //     })
    // },

    // application filter 

    
    async retrieveApplicationSearchDetails() {
      this.isLoading = true
      const payload = {
        "source": this.selectedSource,
        "salesRepName": this.selectedAgentId.employeeId || null,
        // "fromDate": null,
        // "toDate": null,
        "fromDate": this.fromDate || null,
        "toDate": this.toDate || null,
        "appStatus": this.selectedAppStatus || "",
        "dealStatus": this.selectedDealStatus || "",
        // "dealStatus": "Approved",
        "dateType": this.dateType || "",
        // "dateType": "AppDate",
        "leaseNumber": this.leaseNumber || "",
        "creditAnalystId": this.selectedCreditAnalystId.employeeId || null,
        "dealerState":  this.selectedDealerState.stateFipsC || "",
        "year": this.appYear || null,
        "make": this.appMake || "",
        "model": this.appModel || "",
        "stateOfReg": this.selectedAppState.stateFipsC || "",
        "customerId": this.selectedCustomerId.customerId || null,
        "dealerId": this.selectedDealerId.dealerId || null
    }
      await httpdeal.post('/application/search', payload, {params: {'page': this.currentPage - 1, 'size': 10}}).then( async response => {
        if (response.data.errorMessage != null && response.data.errorMessage.length > 0) {
          this.listApps = []
          this.information = 'No Approved Application in the system'
          this.msgcolor.color = 'Red'
        } else {
          var arr = []
          var j = 0
          var fraudreason = []
          var listApps1 = []
          var listApps1 = response.data.content
          for (var i = 0; i < listApps1.length; i++) {
            arr.push(listApps1[i].customerId)
          }
          await httpdeal.get('/quote/dealsTrackingFraudCustomer?customerId=' + arr).then(response => {
            fraudreason = response.data
            for (j = 0; j < listApps1.length; j++) {
              for (var k = 0; k < fraudreason.length; k++) {
                if (listApps1[j].customerId == fraudreason[k].customerId) {
                  if (fraudreason[k].customerFraudReason != '') { listApps1[j]['fraudreason'] = fraudreason[k].customerFraudReason } else { listApps1[j]['fraudreason'] = null }
                }
              }
            }
            this.listApps = listApps1
          })
          this.totalElements = response.data.totalElements
          this.totalPages = response.data.totalPages
        }
        this.initializedata()
        this.selectedapp = ''
        this.isLoading = false
      })

        .catch(e => {
          this.isLoading = false
          this.errors.push(e)
        })
    },

    retriveQuoteDealerStateList () {
      httpdeal.get('/quote/quotedealerstate').then(response => {
        this.quoteDealerStateList = response.data
      })
    },

    // retriveQuoteEmployeeList () {
    //   httpdeal.get('/quote/quoteemployees').then(response => {
    //     if (response.data.length > 0) {
    //       this.quoteAgentsList = response.data.filter((employee) => {
    //         return employee.userRoleC == 'SR'
    //       })
    //       this.quoteCreditAnalystList = response.data.filter((employee) => {
    //         return employee.userRoleC == 'CA'
    //       })
    //     }
    //   })
    // },

    retrieveLeaseNumber: function () {
      httpdeal
        .get('/application/appLeaseNumber')
        .then(response => {
          this.leaseNumberList = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    handleClick (event) {
      this.currentPage = event
      this.retrieveApplicationSearchDetails()
    },


    fetchData () {
      this.retrieveApplicationDetails()
      this.retrieveAgentList()
      this.retrieveAllDealers()
      this.retrieveAllLesseeNames()
      this.retrieveAllStates()
      this.retrieveAllYears()
      this.retrieveAllMakes()
      this.retrieveAllModels()
      this.retriveQuoteDealerStateList()
      this.retrieveLeaseNumber()
      // this.retriveQuoteEmployeeList()
    }
  },
  computed: {
    sortedLesseeNames: function () {
      return this.appCustomersList.sort((a, b) => {
        var obj1Name, obj2Name
        if (a.customerType == 'P') {
          if (a.middleName != null && a.middleName.length != 0) {
            obj1Name = a.firstName + ',' + a.middleName
            if (a.lastName != null && a.lastName.length != 0) {
              obj1Name += a.lastName
            }
          } else {
            if (a.lastName != null && a.lastName.length != 0) {
              obj1Name = a.firstName + a.lastName
            } else {
              obj1Name = a.firstName
            }
          }
        } else if (a.customerType == 'B') {
          obj1Name = a.businessName
        }
        if (b.customerType == 'P') {
          if (b.middleName != null && b.middleName.length != 0) {
            obj2Name = b.firstName + ',' + b.middleName
            if (b.lastName != null && b.lastName.length != 0) {
              obj2Name += b.lastName
            }
          } else {
            if (b.lastName != null && b.lastName.length != 0) {
              obj2Name = b.firstName + b.lastName
            } else {
              obj2Name = b.firstName
            }
          }
        } else if (b.customerType == 'B') {
          obj2Name = b.businessName
        }
        if (obj1Name != null && obj2Name != null) {
          if (obj1Name.toLowerCase() < obj2Name.toLowerCase()) { return -1 }
          if (obj1Name.toLowerCase() > obj2Name.toLowerCase()) { return 1 }
        }
        return 0
      })
    },

    filteredApps: function () {
      // This method will be used to filter the data name

      var filtered = this.listApps
      this.filters.forEach(filter => {
        filtered = filtered.filter(record => {
          return record[filter.name] == filter.value
        })
      })
      return filtered
    },

    sortedDealers: function () {
      return this.dealersList.sort((a, b) => { return a.dealerName > b.dealerName ? 1 : -1 })
    }
  }
}
</script>
<style scoped>
.selected-deal{
background: lightsalmon;
 }
 .non-selected-deal{
background: lightgray;
 }
 .submitButton{
  width: 80px;
}
.wrap-text {
  white-space: nowrap;
}
.nextButton{
    margin: 0px;
    padding: 0px;
    border-radius: 6px;
    font-size : 10px;
    height: 30px;
    width: 100px;
}
thead {
  position: sticky;
  top:0px ;  /* 0px if you don't have a navbar, but something is required */

}
</style>
